import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE,
});

// Ensure Authorization header is present on every request if a token exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config && config.headers && !config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Centralized 401 handling: clear token and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    // Only log out on 401 (invalid/expired token), not 403 (insufficient permissions)
    if (status === 401) {
      // Clear auth and bounce to login; avoids silent failures across the app
      localStorage.removeItem('token');
      delete api.defaults.headers.common["Authorization"];
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        // Use full reload to reset React state
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const setAuthToken = (token: string | null) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

export default api;
